import { ChildMenu, ListItem } from './shared'

export const howCinchWorks: Omit<ChildMenu, 'heading'> = {
  sectionTitle: 'Popular makes',
  navItems: [
    {
      type: 'link',
      label: 'Buying a car online',
      href: '/our-commitment',
    },
    {
      type: 'link',
      label: '3-month warranty',
      href: '/car-care/3-month-warranty',
    },
    {
      type: 'link',
      label: 'Quality standards',
      href: '/car-inspection',
    },
    {
      type: 'link',
      label: 'Home delivery',
      href: '/delivery',
    },
    {
      type: 'link',
      label: 'Collection',
      href: '/car-collections',
    },
    {
      type: 'link',
      label: 'Visit our stores',
      href: '/store',
    },
  ],
}

export const howCinchWorksFAQs: ListItem = {
  sectionTitle: 'FAQs',
  faqs: [
    {
      label: 'Can I buy a new car from cinch?',
      href: 'https://help.cinch.co.uk/hc/en-gb/articles/37926835771165-How-do-I-buy-a-new-car',
      ariaLabel: 'Can I buy a new car from cinch?',
    },
    {
      label: 'Do your cars come with an MOT?',
      href: 'https://help.cinch.co.uk/hc/en-gb/articles/37925336238109-Do-cinch-cars-come-with-an-MOT',
      ariaLabel: 'Do your cars come with an MOT?',
    },
    {
      label: 'How do I apply for finance?',
      href: 'https://help.cinch.co.uk/hc/en-gb/articles/37928138986909-What-should-I-know-before-applying-for-finance',
      ariaLabel: 'How do I apply for finance?',
    },
  ],
  sectionLink: 'Go to help and support',
  href: 'https://help.cinch.co.uk/hc/en-gb',
}
